define('views/parts/form/textarea',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // templates
    'text!templates/parts/form/textarea.html',

], function(
    // Libs
    _, Backbone, Mustache, U,
    // templates
    TPartsFormTextarea
) {

    /**
     * Creates an input box with an inline dynamic label
     * and provides two-way binding via Epoxy.
     *
     * @param  {string} label
     * @param  {string} labelposition [inner|left|top]
     * @param  {string} attribute of the model
     * @param  {string} name of the input element
     * @param  {string} id of the input element
     */
    var VTextarea = Backbone.Epoxy.View.extend({

        template: TPartsFormTextarea,
        events: {
            'focus textarea': 'onTextareaFocus',
            'blur textarea': 'onTextareaBlur',
            'input textarea': 'onTyping',
        },
        regions: {
            label: ".control-label",
            textarea: ".form-control"
        },

        initialize: function(opt) {
            var model = this.model,
                options = this.options = _.extend({
                    attribute: 'value',
                    name: opt.attribute,
                    id: this.cid,
                    needsTranslatedLabel: true,
                    labelposition: 'inner',
                    autosize: false,
                    markdownHelp: false
                }, opt);

            if (!model) {
                this.model = model = new Backbone.Model();
                model.set(options.attribute, null);
            }

            if (options.labelposition === "inner") {
                options.inner = true;
            }

            this.listenTo(this.model, "change:" + options.attribute, this.updateLabel);

        },
        render: function() {
            var html = Mustache.render(this.template, Mustache.getContext(this.options, this.options.namespace));
            this.$el.empty().append(html);
            this.applyBindings();

            this.generateZones();

            this.updateLabel();
            this.setTextareaHeight(true);

            return this;
        },

        getValue: function() {
            return this.model.get(this.options.attribute);
        },

        setValue: function(value, options) {
            this.model.set(this.options.attribute, value, options);
        },

        updateLabel: function() {
            if (this.zone && this.zone.$label) {
                var val = this.model.get(this.options.attribute);
                this.toggleLabel(_.isNumber(val) || !_.isEmpty(val));
            }
        },

        toggleLabel: function(val) {
            this.zone.$label.toggleClass("label-to-top", val);
        },

        setTextareaHeight: function(init) {
            var textarea = this.zone.$textarea[0];
            if (!textarea) textarea = this.zone.$textarea;

            if (Backbone.$(textarea).val()) {
                if (Backbone.$(textarea).val().length > 0 && Backbone.$(textarea).hasClass('autosize')) {
                    textarea.style.height = 'auto';
                    textarea.style.height = textarea.scrollHeight + 'px';
                }
            }
        },

        // form events
        onTextareaFocus: function(e) {
            this.zone.$label.addClass("focus");
            this.toggleLabel(true);
        },

        onTextareaBlur: function(e) {
            var zone = this.zone,
                $textarea = zone.$textarea,
                value = this.getValue();
            zone.$label.removeClass("focus");
            this.toggleLabel(value === "" || value === null);

        },

        onTyping: function(e) {
            this.setTextareaHeight();
        },

        toggleDisabled: function(val) {
            this.zone.$textarea.toggleDisabled(val);
        },

    });

    return VTextarea;

});

